import React from "react";
import styled from "styled-components";
import { Field } from "formik";

const Input = styled.input`
  outline: none;
  user-select: none;
  width: 2.25rem;
  height: 2.5rem;
  &:checked {
    background-color: gold;
  }
`;

export default ({ children, ...props }) => (
  <label className="pointer fw6 white mr1 relative">
    <Field
      name={props.name}
      render={({ field, ...rest }) => (
        <Input
          className="pointer b--none bg-brand input-reset br2 db "
          type="radio"
          {...field}
          {...props}
        />
      )}
    />
    <div className="absolute absolute--fill flex items-center justify-center">
      {children}
    </div>
  </label>
);



// WEBPACK FOOTER //
// ./src/components/common/feedback/LeaveFeedback/RateItem/index.js